import sanitizeHtml, { type IOptions } from "sanitize-html";

/**
 * Rich product / supplier descriptions (HTML from external sources).
 * Scripts, event handlers, and dangerous URLs are stripped.
 */
const PRODUCT_OPTIONS: IOptions = {
  allowedTags: [
    "a",
    "abbr",
    "b",
    "blockquote",
    "br",
    "caption",
    "code",
    "div",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "i",
    "img",
    "li",
    "ol",
    "p",
    "pre",
    "s",
    "small",
    "span",
    "strike",
    "strong",
    "sub",
    "sup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "u",
    "ul",
  ],
  allowedAttributes: {
    "*": ["class"],
    a: ["href", "title", "target", "rel"],
    img: ["src", "alt", "width", "height", "referrerpolicy"],
    th: ["colspan", "rowspan", "width"],
    td: ["colspan", "rowspan", "width"],
  },
  allowedSchemes: ["http", "https", "mailto"],
  allowProtocolRelative: false,
  transformTags: {
    a: sanitizeHtml.simpleTransform("a", { rel: "noopener noreferrer" }),
  },
};

/**
 * Short snippets: plan feature bullets, modal copy from i18n, wizard text.
 * No block layout, media, or links - keeps the XSS surface as small as the
 * content actually needs.
 */
const INLINE_OPTIONS: IOptions = {
  allowedTags: [
    "b",
    "br",
    "em",
    "i",
    "mark",
    // <s>/<strike> carry meaning here: isFeatureCrossedOff() detects them and
    // planCard renders crossed-off plan features with the markup intact.
    "s",
    "small",
    "span",
    "strike",
    "strong",
    "sub",
    "sup",
    "u",
  ],
  allowedAttributes: {
    "*": ["class"],
  },
  allowedSchemes: [],
};

export function sanitizeProductDescriptionHtml(
  html: string | null | undefined
): string {
  if (html == null || html === "") return "";
  return sanitizeHtml(String(html), PRODUCT_OPTIONS);
}

export function sanitizeInlineHtml(html: string | null | undefined): string {
  if (html == null || html === "") return "";
  return sanitizeHtml(String(html), INLINE_OPTIONS);
}
